module.exports = __webpack_public_path__ + "assets/img/roletext-80f28def.png";